import { useDispatch } from "react-redux";

import { UserLocation } from "custom-models";

import { updatePatientAddress } from "shared/actions/admin/adminPatientActions";

import AdminPanel from "components/admin/adminPanel/AdminPanel";
import HalfScreenPanel from "components/admin/editPanels/halfScreenEditPanel/HalfScreenPanel";
import DjangoLink from "components/DjangoLink";

import LocationForm from "./LocationForm";

type LocationPanelProps = {
  setEditLocation: Function;
  title: string;
  location: UserLocation;
  canUpdateLocation?: boolean;
};

const LocationPanel = ({
  setEditLocation,
  title,
  location,
  canUpdateLocation = true,
}: LocationPanelProps) => {
  const dispatch = useDispatch();

  const handleOnClose = () => {
    setEditLocation(null);
  };

  const handleOnSubmit = (values: UserLocation) => {
    values?.id && dispatch(updatePatientAddress(values, handleOnClose));
  };

  return (
    <HalfScreenPanel onClose={handleOnClose}>
      <div className="HalfScreen__container">
        <AdminPanel
          title={{
            prefix: `Location #${location?.id}`,
            main: title,
          }}
          djangoLink={
            <DjangoLink
              route={`pathology/location/${location?.id}/change/`}
              title="Django Location Access"
            />
          }
        >
          <LocationForm
            location={location}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            disableSubmit={!canUpdateLocation}
          />
        </AdminPanel>
      </div>
    </HalfScreenPanel>
  );
};

export default LocationPanel;
